/*
  Team K9 emergency no-op.
  Stale Shopify edge HTML may still request tk9-tone-polish.js from old themes.
  The old runtime rewrote sale copy and could interfere with page interaction.
*/
(function () {
  window.TeamK9TonePolishDisabled = {
    disabledAt: "2026-06-20T17:24:00Z",
    reason: "Disabled after navy theme publish because stale edge HTML still referenced this asset.",
  };
})();
